module.exports = "/* nothing here--delete me */\r\n"